import AssessmentFlowComponent from 'components/assessment-flow';
import { useHistory } from 'react-router-dom';
import { DEPRESSION } from 'components/shared/types';
import { IQuestion } from 'components/assessment-flow/types';
import {
  DEPRESSION_ASSESSMENT_RESULT,
  DEPRESSION_ASSESSMENT_SCORING
} from 'constants/localStorageKey';

const DepressionAssessment = () => {
  const history = useHistory();
  const handleNextPage = () => {
    const data = localStorage.getItem(DEPRESSION_ASSESSMENT_RESULT) || '';
    const assessmentResult = JSON.parse(data) as IQuestion[];
    const score = assessmentResult.reduce(
      (result, question) => result + (question.selectedOption?.score || 0),
      0
    );
    localStorage.setItem(DEPRESSION_ASSESSMENT_SCORING, score.toString());
    history.push('/depression-assessment-email');
  };

  return (
    <AssessmentFlowComponent
      serviceLine={DEPRESSION}
      handleNextPage={handleNextPage}
      storageKey={DEPRESSION_ASSESSMENT_RESULT}
    />
  );
};

export default DepressionAssessment;
